export const formatMinutes = (minutes, hourUnit, detailed = false) => {
  if (minutes === Infinity) {
    return '∞';
  }

  minutes = Math.round(minutes);
  if (minutes < 60) {
    return minutes + 'm';
  } else if (minutes < 60 * 24) {
    let hourString = Math.round(minutes / 60) + hourUnit;
    if (detailed) {
      hourString += Math.ceil((minutes % 60) / 15.0) * 15.0 + 'm';
    }

    return hourString;
  }

  let dayString = Math.round(minutes / (60 * 24)) + 'd';
  if (detailed) {
    dayString += Math.round((minutes % (60 * 24)) / 60) + hourUnit;
  }

  return dayString;
};
